<template>
    <div><!--  class="loading-mask" v-loading="!yjFeeSuffient" element-loading-text="您已拖欠运营商佣金，为了不影响正常使用，请尽快补交！" -->
        <div class="breadcrumb-layout">
            <el-breadcrumb separator=">">
                <el-breadcrumb-item :to="{ path: '>' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>合同服务订单列表</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="swb-back-row">
            <div class="order-title mb10" v-if="flag">
                <div class="order-title-content fl">
                    <ul class="order-status">
                        <li class="">零售商名称：{{contranct.fstPartyName}}</li>
                        <li class="">合同编号：{{contranct.no}}</li>
                        <li v-if="contranct.confirmed">合同状态：合同履约中</li>
                        <li v-if="contranct.fullfilled" class="">合同状态：履约完成</li>
                        <li v-if="contranct.checked" class="">合同状态：已验收</li>
                    </ul>
                </div>
            </div>
            <div class="order-search-container">
                <a class="all-order">全部订单</a>
                <swb-servc-order-search :no="no" :isContract="true" :contractId="contractId" @showServcOrderSearch="showSearch"></swb-servc-order-search>
            </div>
            <div class="orders-list-container">
                <table class="orders-list-panel1">
                    <colgroup>
                        <col width="450px">
                        <col width="250px">
                        <col width="150px">
                        <col width="150px">
                        <col width="100px">
                        <col width="100px">
                    </colgroup>
                    <thead class="orders-header">
                    <tr class="">
                        <th>服务信息</th>
                        <th style="text-align: left">买家信息</th>
                        <th>应付款</th>
                        <th>交付状态</th>
                        <th>交易状态</th>
                        <th>操作</th>
                    </tr>
                    </thead>
                    <tbody class="orders-body" v-if="servOrderList != null && servOrderList.length > 0" v-for="(servcOrder, index) in servOrderList">
                    <tr class="blank-row">
                        <td colspan="6"></td>
                    </tr>
                    <tr class="abstract-row">
                        <td colspan="6">
                            <div class="abstract-content">
                                <span class="mr30">订单号：<a>{{servcOrder.no}}</a></span>
                                <span class="mr30">合同单号：<a>{{servcOrder.contractNo}}</a></span>
                                <!--<span class="mr30">交易单号：<a class="swb-btn-link" @click.stop="toTradeVoucherList(servcOrder.tradeNo)">{{servcOrder.tradeNo}}</a></span>-->
                                <span class="mr30">{{servcOrder.createTime}}</span>
                                <span class="mr30" v-if="servcOrder.trackPhaseName != null">计划阶段：{{servcOrder.trackPhaseName}}</span>
                                <span class="mr30">服务机构：{{servcOrder.servicerComName}}</span>
                            </div>
                            <div v-if="servcOrder.proxied" class="table-tips order"></div>
                        </td>
                    </tr>
                    <tr class="info-row">
                        <td>
                            <div class="goods-info-block" style="overflow: hidden" v-if="servcOrder.itemList != null && servcOrder.itemList.length > 0" v-for="(servcOrderItem, index) in servcOrder.itemList">
                                <div class="goods-item clearfix">
                                    <div class="good-img">
                                        <img v-if="servcOrderItem.servcFileBrowseUrl!= null" class="wh100" :src="servcOrderItem.servcFileBrowseUrl"/>
                                    </div>
                                    <div class="good-msg">
                                        <p class="ellipsis-2 font12 align-left">
                                            <span>{{servcOrderItem.title}}</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td class="align-left">
                            <div class="font12 ellipsis-1">联系人：{{servcOrder.buyerShopContactName}}</div>
                            <div class="font12 ellipsis-1">买家名称:{{servcOrder.buyerName}}</div>
                            <div class="font12 ellipsis-1">联系方式：{{servcOrder.buyerShopContactTel}}</div>
                            <div class="font12 ellipsis-1">机构名称:{{servcOrder.buyerShopName}}</div>
                            <div class="font12 ellipsis-1">机构地址:{{servcOrder.buyerShopAddr}}</div>
                        </td>
                        <td>
                            <div class="font-gray1">
                                <span>总额 ¥<b class="pri">{{(servcOrder.amount).toFixed(2)}}</b></span>
                            </div>
                            <div>
                                <span v-if="checkActionPerm('view_pay_detail') && contractId == null" class="swb-btn-link" @click="resetpay(servcOrder)">收款明细</span>
                            </div>
                        </td>
                        <td>
                            <div v-if="servcOrder.servicerShopFlag == false">待指派网点</div>
                            <div v-if="servcOrder.servicerShopFlag == true">{{servcOrder.servicerShopName}}</div>
                            <div class="font14 font-gray2" v-if="servcOrder.workAssignStateX != null"><span>派工状态:{{workAssignStateX[servcOrder.workAssignStateX]}}</span>
                            </div>
                        </td>
                        <td>
                            <div class="font14 font-gray2" v-if="servcOrder.state != null">{{servcOrder.state}}</div>
                            <div class="swb-btn-link" v-if="checkActionPerm('view_detail')" @click="searchOrder(servcOrder.id)">
                                <i class="icon iconfont"></i><span>订单详情</span>
                            </div>
                        </td>
                        <td>
                            <div class="swb-btn-link" v-if="checkActionPerm('cancel')&&　!servcOrder.cancelled" @click="doCancalServcOrder(servcOrder.id)">
                                <span>取消</span>
                            </div>
                            <div class="swb-btn swb-btn-link" v-if="checkActionPerm('initiate_complaint')" @click="complaintSave(servcOrder.id)">
                                <span>发起投诉</span>
                            </div>
                            <div class="swb-btn swb-btn-link" v-if="checkActionPerm('view_after_sale_order') && servcOrder.hasAfterSafes" @click="searchAfterSale(servcOrder.no)">
                                <span>查看售后订单</span>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="block pagination-layout">
                <el-pagination background class="mt10" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { checkUserActionPerm } from '../index'
    import { getDefaultPageSizes } from '../../app.conf'
    import { showRouteLayer } from '../ctrl/RouteLayer'

    import contractApi from '../../api/contract'
    import userApi from '../../api/user'
    import servcOrderApi from '../../api/servcOrder'
    import servicerApi from '../../api/servicer'

    import SwbServcOrderOperate from './ServcOrderOperate';
    Routes.add(SwbServcOrderOperate);

    import SwbAppointStore from './ServcOrderAppointStore';
    Vue.regist(SwbAppointStore);

    import SwbComplaintSave from '../custsvc/ComplaintSave';
    Routes.add(SwbComplaintSave);

    import SwbTradeVoucherList from '../tradeVoucher/TradeVoucherList';
    Routes.add(SwbTradeVoucherList);

    import SwbAfterSaleOrderList from './AfterSaleOrderList';
    Routes.add(SwbAfterSaleOrderList);

    import SwbRcvVoucherList from '../payment/RcvVoucherList';
    Routes.add(SwbRcvVoucherList);

    import SwbServcOrderSearchLet from './ServcOrderSearchLet'
    Vue.regist(SwbServcOrderSearchLet);

    export default {
        name: 'swb-contract-servc-order-is-self-list',
        path: '/servc/order/list-contract',
        avlActions: 'view_pay_detail|view_detail|appoint_shop|initiate_complaint|view_after_sale_order|cancel',
        avlActionNames: '支付明细、订单详情（新增派工单、查看收费项）、指派门店、发起投诉、查看售后订单',
        avlScopes: 'servicer',
        authen: false,
        desc: '普通服务订单列表',
        helpArticleCode: 'servicer-servc-order-list-contract',
        data: function () {
            return {
                servOrderList: [],
                servcOrderStateList: [],
                workAssignStateX: [],
                servcOrderState: null,
                createOrderStart: null,
                createOrderEnd: null,
                no: null,
                contractId: null,
                contranct: {},
                //
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                isSelf: true,
                contractFlag: false,
                userIsShopFlag: false,
                flag: false,
                value6: '',
                //
                yjFeeSuffient: true, // 默认佣金充足
                //排序、搜索
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
                servcOrderType: "Contract"
            }
        },
        watch: {
            '$route': 'fetchData'
        },
        created: function () {
            //保持pageSize的一致性
            this.pageSize = this.pageSizes.first();
            //
            this.fetchData();
        },
        methods: {
            fetchData: function () {
                let no = this.$route.query.no || null;
                if(!Utils.isNoB(no)) {
                    this.no = no;
                    this.queryModel.filterItems.no = no;
                }
                this.contractId = this.$route.query.contractId || null;
                this.servcOrderStateList = getEnumList("servcOrderState");
                this.workAssignStateX = getEnumMap("workAssignStateX", "value2text");
                if(this.contractId != null) {
                    this.getContractById(this.contractId);
                    this.flag = true;
                }
                this.getCurrentUserInfo();
                // 获取当前商户 佣金是否足额
                this.getCurrentMerchtYjFeeSuffient();
            },
            showSearch: function (data) {
                this.queryModel = data;
                this.pageNumber = 1;
                this.getServOrderList();
            },
            // 检查资源具体操作权限（可选的是否为指定的岗位id）
            checkActionPerm: function (action, targetPostId) {
                return checkUserActionPerm(Vue.$getClassInfo(this).path, action, targetPostId);
            },
            getCurrentMerchtYjFeeSuffient: function () {
                let self = this;
                servicerApi.getServicerYjFeeSuffient({}, function (result) {
                    if(result.type == 'info') {
                        //
                        self.yjFeeSuffient = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getContractById: function (contractId) {
                let self = this;
                let postData = {};
                postData.id = contractId;
                //
                let loading = MsgBox.loading();
                contractApi.getContractInfo(postData, function (result) {
                    if(result.type == "info") {
                        self.contranct = result.data;
                        loading.close();
                    }
                });
            },
            getCurrentUserInfo: function () {
                let self = this;
                userApi.getUserInfoByContext({}, function (result) {
                    if(result.type == "info") {
                        self.userIsShopFlag = result.data.scopeEntity.shopFlag;
                        let servcOrderStateList = getEnumList("servcOrderState", true);
                        if(self.userIsShopFlag) {
                            for(let i = 0; i < servcOrderStateList.length; i++) {
                                let servcOrderState = servcOrderStateList[i];
                                if(servcOrderState.value == 2) {
                                    servcOrderStateList.splice(i, 1);
                                }
                            }
                        }
                        self.servcOrderStateList = servcOrderStateList;
                        self.getServOrderList();
                    }
                })
            },
            selectionMenu: function (value) {
                let self = this;
                let servcOrderStateList = self.servcOrderStateList;
                for(let i = 0; i < servcOrderStateList.length; i++) {
                    let servcOrderState = servcOrderStateList[i];
                    if(servcOrderState.value == value) {
                        self.servcOrderState = value;
                        self.getServOrderList();
                    }
                }
            },
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                let self = this;
                this.pageNumber = val;
                this.getServOrderList();
            },
            getServOrderList: function () {
                let self = this;
                let postData = {};

                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                filterItems.isSelf = self.isSelf;
                filterItems.contractFlag = true;
                if(!Utils.isNoB(self.contractId)) {
                    filterItems.contractId = self.contractId;
                }
                if(self.servcOrderState == 2) {
                    filterItems.servicerShopFlag = false;
                }
                //
                filterItems.servcOrderType = this.servcOrderType;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                let loading = MsgBox.loading();
                servcOrderApi.getServOrderList(postData, function (result) {
                    if(result.type == "info") {
                        let data = result.data;
                        let servOrderList = data.rows;
                        //
                        self.servOrderList = servOrderList;
                        //
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                        loading.close();
                    } else {
                        loading.close();
                        MsgBox.warning(result.message);
                    }
                });
            },
            appointOption: function (id) {
                let self = this;
                Vue.$showDialog({
                    title: '指定门店',
                    showCloseBtn: true,
                    height: '80%',
                    template: '<div>' +
                    '<swb-servc-order-appoint-store :servcOrderId="servcOrderId" ref="swb_servc_order_appoint_store"></swb-servc-order-appoint-store>' +
                    '</div>',
                    data: {
                        servcOrderId: null
                    },
                    methods: {},
                    okClicked: function () {
                        let selfDlg = this;
                        let result = selfDlg.$refs.swb_servc_order_appoint_store.getDlgResult() || {};
                        if(result != null && result.type === 'info') {
                            let postData = {};
                            postData.servicerShopId = result.data.id;
                            postData.id = id;
//                            postData.submitted = true;
                            let loading = MsgBox.loading();
                            servcOrderApi.designateServcShop(postData, function (result) {
                                if(result.type == "info") {
                                    loading.close();
                                    self.getServOrderList();
                                    return true;
                                } else {
                                    loading.close();
                                    MsgBox.warning(result.message);
                                }
                            });
                            return true;
                        } else {
                            MsgBox.warning(result.message);
                        }
                        return false;
                    },
                    lifecycle: {
                        created: function () {
                            this.servcOrderId = id;
                        }
                    }
                });
            },
            selectionMenu: function (value) {
                let self = this;
                let servcOrderStateList = self.servcOrderStateList;
                for(let i = 0; i < servcOrderStateList.length; i++) {
                    let servcOrderState = servcOrderStateList[i];
                    if(servcOrderState.value == value) {
                        self.servcOrderState = value;
                        self.getServOrderList();
                    }
                }
            },
            searchOrder: function (orderId) {
                this.$router.push({
                    path: SwbServcOrderOperate.path,
                    query: {
                        id: orderId,
                    }
                });

            },
            // 发起投诉
            complaintSave: function (orderId) {
                let subjectType = getEnumInfoWith("complaintSubjectType", "name", "ServcOrder");
                //
                this.$router.push({
                    path: SwbComplaintSave.path,
                    query: {
                        orderId: orderId,
                        subjectType: subjectType.value,
                    }
                })
            },
            toTradeVoucherList: function (tradeNo, contractId) {
                let self = this;
                let tradeType = getEnumInfoWith("tradeVoucherType", 'name', 'ContractVoucher').value;
                self.$router.push({
                    path: SwbTradeVoucherList.path,
                    query: {
                        no: tradeNo,
                        tradeVoucherType: tradeType
                    }
                })
            },
            searchAfterSale: function (no) {
                this.$router.push({
                    path: SwbAfterSaleOrderList.path,
                    query: {no: no}
                })
            },
            resetpay: function (row) {
                let srcVoucherType = getEnumInfoWith("srcVoucherType", "name", "Order").value;
                let query = {srcVoucherType: srcVoucherType, srcVoucherId: row.id, srcVoucherInnerNo: row.no};
                showRouteLayer({
                    title: "收款明细",
                    query: query,
                    template: SwbRcvVoucherList
                });
            },
            doCancalServcOrder: function (orderId) {
                let self = this;
                self.$prompt('请输入取消原因', '取消确认对话框', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(function (data) {
                    let cancelCause = data.value;
                    //
                    let postData = {};
                    postData.orderId = orderId;
                    postData.cancelCause = cancelCause;
                    //
                    let msgBoxDlg = MsgBox.loading();
                    servcOrderApi.doCancelServcOrder(postData, function (result) {
                        if(result.type == "info") {
                            MsgBox.info("操作成功");
                            setTimeout(function () {
                                self.getServOrderList();
                                msgBoxDlg.close();
                            }, 3000);
                        } else {
                            msgBoxDlg.close();
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {

                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/servcOrder/ContractServcOrderList.vue